import apiClient from "./apiClient";

// DAS-129 — 서버 자원/배치 현황 (클라우드/로컬 구분 + 별칭 + 유휴 표기 확장).
// 응답: { hosts: [{ host, name, category, provider, role, service, reserved, idle,
//                   location, strategies, metrics_source, metrics, reachable, runs_paper_trader }] }
//   - host: IP/식별자 (프론트 별칭 저장 키)
//   - category: "cloud" | "local"   provider: "AWS" | "Oracle Cloud" | "On-prem"
//   - service: 가동 중 프로세스/포트 (예: "uvicorn :8000")   idle: 유휴 서버 여부
//   - metrics_source: "self"(EC2 직접) | "agent"(NUC·Mac mini) | "none"(정적)
//   - metrics: { cpu_percent, mem_used_mb, mem_total_mb, disk_used_gb, disk_total_gb, uptime_sec, ok } | null
// go-server 가 self + agent(Redis 캐시) 호스트 메트릭을 서버측 fan-out 으로 집계한다.
export const fetchSystemResources = () => {
    return apiClient.get("/api/system/resources");
};

export const fetchInfraStatus = () => {
    return apiClient.get("/api/infra/status");
};

export const fetchInfraErrors = (params = {}) => {
    return apiClient.get("/api/infra/errors", { params });
};

export const fetchInfraErrorStats = () => {
    return apiClient.get("/api/infra/errors/stats");
};

export const fetchInfraHealth = () => {
    return apiClient.get("/api/infra/health");
};
